import React, { useEffect } from "react";
import "./Banner.css";
import axios from "axios";
import Common_Title_1 from "../../common/common_components/common_title_1/Common_Title_1";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AllBanner, WelcomeText } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";
import parse from "html-react-parser"

function Banner() {

  const navigate = useNavigate()

  const dispatch = useDispatch();

  const banners = useSelector((state) => state.common.all_banners);
  const welcomeText = useSelector((state) => state.common.welcomeText);

  // console.log({ banners });


  useEffect(() => {
    dispatch(AllBanner());
    dispatch(WelcomeText());
  }, [dispatch])

  return (
    <section className="home_ban_sec">
      <div className="container">
        <div className="banner_div">
          <div className="row">
            <div className="col-md-10 mx-auto">
              <div className="banflex">
                {
                  banners?.map((banner, idex) => {

                    let fistDivClass;
                    let secondDivClass;

                    if (idex === 0) {
                      fistDivClass = "leftdiv order-md-1 order-2 "
                      secondDivClass = "leftimg zoom_in_out"

                    } else if (idex === 1) {
                      fistDivClass = "middiv order-md-2 order-1"
                      secondDivClass = "centerimg zoom_in_out"
                    } else {
                      fistDivClass = "rightdiv order-md-3 order-3"
                      secondDivClass = "rightimg zoom_in_out"
                    }

                    return (
                      <div className={fistDivClass} onClick={() => { navigate(banner?.link) }}>
                        <img className={secondDivClass} src={IDS?.IMG_URL + banner?.image} alt={banner?.name} />
                        {/* {banner?.name} */}
                      </div>
                    )
                  })
                }

                {/* <div className="leftdiv order-md-1 order-2 " onClick={() => { navigate("/about-us") }}>
                  <img className="leftimg zoom_in_out" src={process.env.PUBLIC_URL + '/assets/images/home/banner/left.png'} alt="leftimg" />
                </div>
                <div className="middiv order-md-2 order-1" onClick={() => { navigate("/gurudev") }}>
                  <img className="centerimg zoom_in_out" src={process.env.PUBLIC_URL + '/assets/images/home/banner/mid.png'} alt="midimg" />
                </div>
                <div className="rightdiv order-md-3 order-3" onClick={() => { navigate("/vision-mission") }}>
                  <img className="rightimg zoom_in_out" src={process.env.PUBLIC_URL + '/assets/images/home/banner/right.png'} alt="rightimg" />
                </div> */}
              </div>
            </div>
          </div>

          <div className="overlaydata">
            <div className="bgimgdiv">
              <img className="bgimg" src={process.env.PUBLIC_URL + '/assets/images/home/banner/Yellow_Patch.png'} alt="background" />
            </div>

            <div className="contentdiv">
              <div className="row">
                <div className="col-lg-8 col-md-10 mx-auto">
                  <div className='Common_Title_1'>
                    <div className='row'>
                      <div className='col-12'>
                        <p className='title_text'>WELCOME</p>
                        <p className='sub_text'>{welcomeText?.name || " "}</p>
                      </div>

                    </div>
            
                  <p className="content_text">{parse(welcomeText?.description || " ")} </p>

                  <Link to="/about-us" className="knowmorep ">Know More</Link>
                </div>
                      </div>
              </div>
            </div>
            {/* <div className="contentdiv">
              <div className="row">
                <div className="col-lg-8 col-md-10 mx-auto">
                  <div className='Common_Title_1'>
                    <div className='row'>
                      <div className='col-12'>
                        <p className='title_text'>WELCOME</p>
                        <p className='sub_text'>Experience a Divinity at Om Tapovan Ashram</p>
                      </div>

                    </div>
                  </div>
                  <p className="content_text"><span>
                    Our ashram offers a diverse programme of lessons & training courses in different spheres such as -</span>
                    Meditation teachings, Dhyan Sadhna, Pran Chikitsa, Kriya Yog, Vibrations and so on.Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,remaining essentially unchanged.
                  </p>

                  <Link to="/about-us" className="knowmorep ">Know More</Link>
                </div>
              </div>
            </div> */}
          </div>


        </div>
      </div>


    </section>
  );
}

export default Banner;
